import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import { font18, font24 } from 'approot/shared/styles/typography.style';
import { flexSpaceBetweenCss } from 'approot/shared/styles/flex.style';
import { spacing12, spacing32 } from 'approot/shared/styles/spacing.style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const ClassResponseListItem = styled.li`
  margin-bottom: ${rem(spacing32)};
`;

export const ClassResponseListContent = styled.div`
  flex-grow: 1;
`;

export const ClassResponseListItemText = styled.div`
  ${flexSpaceBetweenCss}
  ${font18}
  margin-bottom: ${rem(spacing12)};

  ${mediaUp.md`
    ${font24}
  `}
`;

export const ClassResponseListItemStatus = styled(Box).attrs({
  $gap: 4,
  $alignItems: 'center',
})`
  flex-shrink: 0;
`;
